@if (isExternalUrl) {
  <a
    href="{{ url }}"
    [target]="target"
    [attr.rel]="target === '_blank' ? 'noopener noreferrer' : null"
  >
    {{ value | translate }}
  </a>
} @else {
  <a [routerLink]="url" [target]="target" routerLinkActive="active">
    {{ value | translate }}
  </a>
}
